
/// <reference path="../../typings/tsd.d.ts" />
module warsApp.controllers {
    export interface IEditableWebPageScope extends angular.IScope {
        model: models.EditableWebPageModel
    }

    export class EditableWebPageController implements IController {
        constructor(
            private scope: IEditableWebPageScope,
            $routeParams: angular.route.IRouteParamsService,
            contentPageService: warsApp.services.ContentPageService,
            editableContentPageService: warsApp.services.EditableContentPageService,
            processTypeService: services.ProcessTypeService,
            modalService: any) {

            var contentPageId = $routeParams["id"];

            this.scope.model = new models.EditableWebPageModel(
                contentPageId,
                contentPageService,
                editableContentPageService,
                processTypeService,
                modalService
            );
        }
    }
}

warsApp.registerController('EditableWebPageController', ['$scope', '$routeParams', 'contentPageService', 'editableContentPageService', 'processTypeService', 'ModalService']);